import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getOrg, getToken } from 'ducks/auth/selectors';
import { fetchLuzmoReports } from 'services/luzmo';

const useLuzmoReports = () => {
  const org = useSelector(getOrg);
  const sessionToken = useSelector(getToken);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setReports([]);
      setError(null);
      if (!sessionToken) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);

      try {
        const orgReports = await fetchLuzmoReports();
        if (!cancelled) setReports(orgReports);
      } catch (err) {
        if (!cancelled) {
          setError(err?.message || 'Unable to load reports.');
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [org, sessionToken]);

  return { reports, isLoading, error, org };
};

export default useLuzmoReports;
